import { createExploreMini } from '/explore_field_functions/explore_functions.js';
import { createElement } from "/elements_functions/new_elements.js";
import { createSubscribeToFamilyButton, createUnsubscribeFromFamilyButton } from '/buttons_functions/subscribe_to_family_button.js';

export function createNodeExploreSection(nodeObject, subscriptionStatus, subscribersCount) {
    const nodeFamilySection = createElement('section', 'node-family', null);
    
    const exploreFieldMini = createExploreMini(nodeObject);
    const nodeFamilyCaptionAndSubscribeButton = createElement('div', 'node-family-caption-and-subscribe-button', null);
    const nodeFamilyCaption = createElement('h6', 'node-family-caption', null);
    nodeFamilyCaption.innerText = 'The Family Tree';
    let nodeFamilySubscribeButton;

    if(subscriptionStatus===true) {
        nodeFamilySubscribeButton = createUnsubscribeFromFamilyButton(nodeObject.id, subscribersCount);
    } else {
        nodeFamilySubscribeButton = createSubscribeToFamilyButton(nodeObject.id, subscribersCount);
    }
    nodeFamilyCaptionAndSubscribeButton.append(nodeFamilyCaption, nodeFamilySubscribeButton);
    nodeFamilySection.append(nodeFamilyCaptionAndSubscribeButton, exploreFieldMini);

    return nodeFamilySection;
    
}